import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { PaymentRates } from './Pages/listing';

export const PaymentRatesRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={PaymentRates} />
    </Fragment>
)